<script setup lang="ts">
import BaseIcon from '@/components/base/baseIcon.vue'
import { iconNames } from '@/enums/iconNames'

interface Props {
  title: string
}
const props = withDefaults(defineProps<Props>(), {})
</script>

<template>
<div class="flex place-items-center gap-1 rounded-full bg-[--algo-primary-hadfield] font-semibold text-[--algo-base-white] px-[12px] py-[8px] text-[12px]"> 
  {{ props.title }} 
  <BaseIcon :icon-name="iconNames.EXCLUSIVECIRCLE" :size="16" />
</div>
</template>